 <div class="text-left">
  <input  class="form-control mr-1" (keyup)="searchProfile($event.target.value)" type="text" placeholder="Profile name...">
  <div class="compare-selected mx-1 mt-3 p-2 mb-sm-3" *ngIf="selectedProfile !== undefined">
    <p class="mb-2 font-weight-bold text-trimmed">
      &#64;{{selectedProfile.profile}}
    </p>
    <p class="status-label my-1">
      <span class="status-green" *ngIf="selectedProfile.status === 2"><span class="dot"></span>Full report</span>
      <span class="status-orange" *ngIf="selectedProfile.status === 0"><span class="dot"></span>Trial report</span>
    </p>
    <p class="sub-text">
      - {{selectedProfile.added_time * 1000 | date}}
      <!--<span class="float-right linked"><i class="flaticon-cancel"></i></span>-->
    </p>
  </div>
   <div class="autocomplete" *ngIf="show">
    <div class="autocomplete-header">
      Choose from your last audits
    </div>
    <div class="autocomplete-body">
      <ul *ngIf="(profileState | async).audits._embedded !== undefined">
        <li *ngFor="let profile of (profileState | async).audits._embedded.items" (click)="onSelectProfile(profile)" class="">
          <span class="status-label mr-1">
            <span class="status-green" *ngIf="profile.status === 2"><span class="dot"></span></span>
            <span class="status-orange" *ngIf="profile.status === 0"><span class="dot"></span></span>
          </span>
          {{profile.profile}} - {{profile.added_time * 1000 | date}}
          <span class="status-label ml-1">
            <span class="status-orange" *ngIf="profile.status === 0">Trial</span>
          </span>
        </li>
      </ul>
    </div>
<!--    <div>-->
<!--      <div class="autocomplete-header">-->
<!--        Or generate new audit-->
<!--      </div>-->
<!--      <div class="spinner" *ngIf="!(profileState | async).loader['auditAdd']['add']"></div>-->
<!--      <app-profile-form size="small" class="p-1" [redirect]="false"></app-profile-form>-->
<!--    </div>-->
  </div>
 </div>

